import {
  IconTick,
  Box,
  Stack,
  Text,
  List,
  Heading,
  IconInfo,
  Inline,
  IconAI,
} from 'braid-design-system';
import React from 'react';

import LayoutBox from 'src/components/LayoutBox/LayoutBox';
import {
  getMobileProductDetails,
  type MainListingProduct,
} from 'src/data/listing-products/mobile';
import {
  isAccelerate,
  isFreemiumExperiment,
  isStandard,
} from 'src/data/listing-products/products';
import type { ListingProductWithPackageInfo } from 'src/data/listing-products/shared';
import { ListingProductCode } from 'src/generated/graphql';

import SelectButton from '../SelectButton/SelectButton';

interface MobileFeatureProps {
  product: ListingProductWithPackageInfo;
}

const MobileFeatures = ({ product }: MobileFeatureProps) => {
  const { features, info } = getMobileProductDetails(
    // MainListingProduct is a fixed subset of ListingProductCode
    product.productCode as MainListingProduct,
  );

  return (
    <Box marginY="small">
      <Stack space="large">
        {product.productCode === ListingProductCode.PayPerEnquiry && (
          <Stack space="small" align="center">
            <Inline alignY="bottom" space="xsmall">
              <Text size="large">$80 per enquiry</Text>
              <Text>+ GST</Text>
            </Inline>

            <Text tone="info">Capped at $960 + GST</Text>

            <Text size="small" tone="info">
              <i>Subsequent enquires are free</i>
            </Text>
          </Stack>
        )}
        <Stack space="small" align="center">
          <LayoutBox maxWidth={260}>
            <Stack space="medium">
              {isStandard(product.productCode) && (
                <Text
                  icon={<IconAI />}
                  align="center"
                  weight="strong"
                  tone="promote"
                >
                  Recommended
                </Text>
              )}
              {isFreemiumExperiment &&
              (isAccelerate(product.productCode) ||
                isStandard(product.productCode)) ? (
                <Heading level="4">
                  Everything in{' '}
                  {isStandard(product.productCode) ? 'Free' : 'Standard'}, plus:
                </Heading>
              ) : (
                <></>
              )}
              <List type="icon" icon={<IconTick tone="positive" />}>
                {features.map((feature, key) => (
                  <Text data={{ testid: 'mobile-product-feature' }} key={key}>
                    {feature}
                  </Text>
                ))}
              </List>
              <List type="icon" icon={<IconInfo tone="info" />}>
                {info.map((item, key) => (
                  <Text data={{ testid: 'mobile-product-info' }} key={key}>
                    {item}
                  </Text>
                ))}
              </List>
            </Stack>
          </LayoutBox>
        </Stack>
        <SelectButton product={product} />
      </Stack>
    </Box>
  );
};

export default MobileFeatures;
